<template>
  <div>
    <template v-if="loaders.summaryUsage">
      <v-row>
        <v-col v-for="box in (1, 4)" :key="box">
          <v-skeleton-loader
            class="mx-auto"
            max-width="300"
            type="image"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </template>
    <div class="container mx-auto" v-else>
      <v-row>
        <v-col v-for="status in statuses" :key="status.friendly_name">
          <v-card>
            <v-card-item>
              <v-card-title>
                {{ status.friendly_name }}
              </v-card-title>
              <v-card-subtitle class="mt-1">
                <span style="font-size: 25px">
                  {{ getStatusUsage(status.name) }}
                </span>
              </v-card-subtitle>
            </v-card-item>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesforceDashboard',
  data() {
    return {
      statuses: [],
      summaryUsage: {
        'new-requests': 0,
        cancelled: 0,
        'in-progress': 0,
        completed: 0,
      },
      loaders: {
        summaryUsage: true,
      },
    };
  },
  created() {
    this.getStatuses();
  },
  methods: {
    getStatusUsage(status) {
      return this.summaryUsage[status] || 0;
    },
    getStatuses() {
      this.axios.get('secret-shop-statuses').then(({ data }) => {
        const { statuses } = data;
        this.statuses = statuses;

        this.getUsageSummaries();
      });
    },
    getUsageSummaries() {
      this.loaders.summaryUsage = true;
      this.axios.get('salesforce-usage').then(({ data }) => {
        this.summaryUsage = data.shop_request;

        this.$nextTick(() => {
          this.loaders.summaryUsage = false;
        });
      });
    },
  },
};
</script>
